/**
 * Assessment Context definition (separate from component for react-refresh)
 */

import { createContext } from "react";
import type { AssessmentResult } from "../hooks/useAssessment";
import type { TechStackInput } from "./techStacks";

export interface AssessmentContextValue {
  result: AssessmentResult | null;
  isProcessing: boolean;
  runNewAssessment: (input: TechStackInput) => void;
  clearAssessment: () => void;
}

export const AssessmentContext = createContext<AssessmentContextValue | null>(null);
